import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { ref: "content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({'pretty_block': _ctx.opened,'transition': 1})
  }, [
    _createElementVNode("div", {
      class: _normalizeClass({'pretty_button':1, 'd-flex':1 ,'justify-content-between':1,'align-items-center':1,'mb-2':1,'p-2':1,'active': _ctx.opened}),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openPanel()))
    }, [
      _renderSlot(_ctx.$slots, "title"),
      _createElementVNode("div", null, [
        _createElementVNode("i", {
          class: _normalizeClass({dropdown_arrow:1,dropped_down: _ctx.opened})
        }, null, 2)
      ])
    ], 2),
    _createElementVNode("div", {
      style: _normalizeStyle({height: _ctx.height + 'px',transition: 'all .2s ease-in-out'}),
      class: "overflow-hidden"
    }, [
      _createElementVNode("div", _hoisted_1, [
        _renderSlot(_ctx.$slots, "content")
      ], 512)
    ], 4)
  ], 2))
}